import { render, staticRenderFns } from "./erDataTables.vue?vue&type=template&id=5046d7f7&"
import script from "./erDataTables.vue?vue&type=script&lang=js&"
export * from "./erDataTables.vue?vue&type=script&lang=js&"
import style0 from "./erDataTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports